module.exports = __webpack_public_path__ + "static/light-logo-16-1ac1afe0e19211602724571f0cb21ad6.png";